
import React from "react";
// import img1 from "./imgs/R-smart-classic-c.jpg";
import {DEFAULT_LOCALE, LOCALES_HELPER} from "../../../../locales/config";
// import img1en from "./imgs/3-R-Smart Classic.jpg";

export function RSmartClassic() {

    const lang = LOCALES_HELPER.getLan();

    return (
        <>
            {lang === DEFAULT_LOCALE
                ? <>
                </>
                : <>
                    {/* <img className="product-img" src={img1en}/> */}
                </>
            }
        </>
    )
}